export default {
  name: "KilaKilaDivider"
};